import { Inputfiledsbase } from './models/inputfiledsbase';

export class DropdownQuestion extends Inputfiledsbase<string> {
  override controlType = 'dropdown';
}